import React, { useState, useEffect } from 'react';
// import Loading from '../general/Loading';
import { useNavigate } from 'react-router-dom';

const AddPurchase = (props) => {
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    party_name: '',
    party_mobile: '',
    party_address: '',
    party_gst: '',
    date: '',
    paymentMethod: '',
    amountPaid: '',
    totalAmount: 0,
    items: [{ itemId: '', itemName: '', quantity: 1 }]
  });

  const [items, setItems] = useState([]);

  useEffect(() => {
    // setLoading(true);
    Promise.all([
      fetch(`https://api.dectwinhotel.com/api/${props.id}_foods/foods`).then(res => res.json())
    ])
      .then(([productData]) => {
        setItems(productData);
      })
      .catch(console.error)
      // .finally(() => setLoading(false));
  }, []);


  const handleInputChange = (field, value) => {
    setFormData(prev => ({ ...prev, [field]: value }));
  };


const handleItemChange = (index, field, value) => {
  const updatedItems = [...formData.items];

  if (field === 'itemId') {
    const selectedItem = items.find(i => i.food_id == value);

    updatedItems[index].itemId = value;
    updatedItems[index].itemName = selectedItem?.food_name || '';
  } else if (field === 'quantity') {
    updatedItems[index].quantity = parseInt(value, 10);
  }

  const total = updatedItems.reduce((sum, item) => {
    const selectedItem = items.find(i => i.food_id == item.itemId);
    const price = selectedItem?.price || 0;
    return sum + price * item.quantity;
  }, 0);

  setFormData(prev => ({
    ...prev,
    items: updatedItems,
    totalAmount: total
  }));
};


const addItemField = () => {
  const updatedItems = [...formData.items, { itemId: '', itemName: '', quantity: 1 }];
  setFormData(prev => ({
    ...prev,
    items: updatedItems
  }));
};

const removeItemField = (index) => {
  const updatedItems = formData.items.filter((_, i) => i !== index);

  const total = updatedItems.reduce((sum, item) => {
    const selectedItem = items.find(i => i.food_id == item.itemId);
    const price = selectedItem?.price || 0;
    return sum + price * item.quantity;
  }, 0);

  setFormData(prev => ({
    ...prev,
    items: updatedItems,
    totalAmount: total
  }));
};


const handleSubmit = async (e) => {
  e.preventDefault();
  props.handleLoading();
  // setLoading(true);

  try {
    const res = await fetch(`https://api.dectwinhotel.com/api/${props.id}_purchase_bill/add-purchase`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(formData)
    });

    if (!res.ok) throw new Error('Failed to add purchase');

    setFormData({
      party_name: '',
      party_contact: '',
      party_address: '',
      party_gst: '',
      date: '',
      paymentMethod: '',
      amountPaid: '',
      totalAmount: 0,
      items: [{ itemId: '', itemName: '', quantity: 1 }]
    });

          props.handleToast({
        toastMsg: "Purchase Bill Added Successfully!!!",
        toastColor: "#4CAF50",
      });

  } catch (error) {
          props.handleToast({
        toastMsg: "Something went wrong. Try again.",
        toastColor: "#FF0000",
      });
    console.error(error);
  } finally {
      props.closeLoading();
  }
};


  return (
    <>
    <section style={{ padding: "0rem 1rem" }}>
      <div className="add-food-container" style={{maxWidth: '100%'}}>
            {/* <p className="page-title">Add Purchase</p> */}
          <h2 className="form-title text-start">Add Purchase</h2>


          <form className="row g-3" onSubmit={handleSubmit}>

<div className='text-end'>
          <button className='btn btn-primary px-3 py-1 me-2' onClick={() => props.setShowPurchase(false)}>Go Back</button>
          <button className='submit-btn px-3 py-1' onClick={() => navigate('/admin/add-food')}>+ New Item</button></div>

            <div className="col-md-8">
              <label className="profile-label">Date</label><br />
              <input
                type="date"
                className="product-control col-md-5"
                value={formData.date}
                onChange={e => handleInputChange('date', e.target.value)}
                required
              />
            </div>

            <div className="col-md-4">
              <label className="profile-label">Party Contact</label><br />
              <input
                type="number"
                className="product-control"
                value={formData.party_contact}
                onChange={e => handleInputChange('party_contact', e.target.value)}
                required
              />
            </div>

                        <div className="col-md-8">
              <label className="profile-label">Party Name</label><br />
              <input
                type="text"
                className="product-control col-md-5"
                value={formData.party_name}
                onChange={e => handleInputChange('party_name', e.target.value)}
                required
              />
            </div>

            <div className="col-md-4">
              <label className="profile-label">Address</label><br />
              <input
                type="text"
                className="product-control"
                value={formData.party_address}
                onChange={e => handleInputChange('party_address', e.target.value)}
                required
              />
            </div>


            <div className="col-12 mt-4">
              <div className="row fw-semibold mb-1">
                <div className="profile-label col-md-5">Item</div>
                <div className="profile-label col-md-2">Qty</div>
                <div className="profile-label col-md-2">Price/Unit</div>
                <div className="profile-label col-md-2">Amount</div>
              </div>

              {formData.items.map((item, index) => {
                const selectedItem = items.find(i => i.food_id == item.itemId);
                const itemPrice = selectedItem?.price || 0;

                return (
                  <div className="row mb-2" key={index}>
                    <div className="col-md-5">
                      <select
                        className="product-control"
                        value={item.itemId}
                        onChange={e => handleItemChange(index, 'itemId', e.target.value)}
                        required
                      >
                        <option value="">Select Item</option>
                        {items.map(i => (
                          <option key={i.food_id} value={i.food_id}>{i.food_name}</option>
                        ))}
                      </select>
                    </div>

                    <div className="col-md-2">
                      <input
                        type="number"
                        min="1"
                        className="product-control"
                        value={item.quantity}
                        onChange={e => handleItemChange(index, 'quantity', e.target.value)}
                        required
                      />
                    </div>

                    <div className="col-md-2">
                      <input
                        type="number"
                        className="product-control"
                        value={itemPrice}
                        readOnly
                      />
                    </div>

                    <div className="col-md-2">
                      <input
                        type="number"
                        className="product-control"
                        value={itemPrice * item.quantity}
                        readOnly
                      />
                    </div>

                    <div className="col-md-1 mt-2">
    <button
      type="button"
      className="btn btn-sm btn-danger"
      onClick={() => removeItemField(index)}
      disabled={formData.items.length === 1}
    >
      ×
    </button>
  </div>
                  </div>
                );
              })}

              <button type="button" className="submit-btn px-3 py-1" onClick={addItemField}>Add +</button>
            </div>

            <div className="col-md-9">
              <label className="profile-label">Payment Method</label><br />
              <select
                className="product-control col-md-4"
                value={formData.paymentMethod}
                onChange={e => handleInputChange('paymentMethod', e.target.value)}
                required
              >
                <option value="">Select Payment Method</option>
                <option value="Cash">Cash</option>
                <option value="UPI">UPI</option>
                <option value="Credit Card">Credit Card</option>
                <option value="Debit Card">Debit Card</option>
              </select>

<br />

              <label className="profile-label mt-2 text-danger">Due Amount</label><br />
<input
  type="number"
  className="product-control col-md-4"
  value={Math.max(formData.totalAmount - Number(formData.amountPaid || 0), 0)}
  readOnly
/>

            </div>

            <div className="col-md-3">
              <label className="profile-label">Total Amount</label><br />
              <input
                type="number"
                className="product-control"
                value={formData.totalAmount}
                readOnly
              />

              <label className="profile-label mt-2 text-success">Amount Paid</label><br />
              <input
                type="number"
                className="product-control"
                value={formData.amountPaid}
                onChange={e => handleInputChange('amountPaid', e.target.value)}
                required
              />
            </div>

            <div className="col-12 text-end">
              <button type="submit" className="checkout-btn">Save Bill</button>
            </div>
          </form>
        </div>
      </section>

      {/* {loading && <Loading setLoading={setLoading} />} */}
    </>
  );
};

export default AddPurchase;
